<template>
  <div>
    <div class="form-row">
      <div class="form-field">
        <label>
          ФИО:
        <input
          type="text"
          v-model="newAuto.FIO"
        />
        </label>
      </div>
      <div class="form-field">
        <label>
          Лицо:
          <select v-model="newAuto.FACE">
            <option v-for="(face, key) in faces" :key="key" :value="face.ID" >{{face.USER_NAME}}</option>
          </select>
        </label>
      </div>
      <div class="form-field">
        <label>
          Марка:
          <input
            type="text"
            v-model="newAuto.DATA.MANUF"
          />
        </label>
      </div>
      <div class="form-field">
        <label for="auto-type-select">Выберите тип ТС:</label>
        <select id="auto-type-select" v-model="newAuto.autoType">
          <option value="passenger">Легковой</option>
          <option value="cargo">Грузовой</option>
        </select>
      </div>
      <div class="form-field">
        <label>
          Цвет:
          <input
            type="text"
            v-model="newAuto.DATA.COLOR"
          />
        </label>
      </div>
      <div class="form-field">
        <label>
          Регистрационный знак:
          <input
            type="text"
            v-model="newAuto.number"
          />
        </label>
      </div>
      <div class="form-field">
        <label for="kpp-type-select">Выберите тип проезжающего:</label>
        <select id="kpp-type-select" v-model="newAuto.KPP_TYPE">
          <option
            v-for="(type, key) in kppTypes"
            :value="type.ID"
            :key="key"
          >
            {{ type.NAME }}
          </option>
        </select>
      </div>
      <div class="form-field">
        <button @click="sendUserData">Добавить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "addAuto",
  props: ["plot"],
  data() {
    return {
      url: config.backend_url,
      info: null,
      newAuto: {
        DATA: {
        }
      },
      idPlot: this.plot,
      features: [],
      services: [],
      documents: [],
      faces: [],
      kppTypes: []
    };
  },
  computed: {},
  methods: {
    sendUserData: function() {
      let self = this;
      this.newAuto.plot_id = this.idPlot;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "plots/add-veh/",
          data: this.newAuto,
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (data) {
            self.info = "Транспортное средство добавлено";
            self.$emit("auto-add");
          }
        });
    },
    getServicesList: function() {
      let self = this;
      this.$store
        .dispatch("query/sendRequest", {
          url: self.url + "services/get/",
          data: {},
          method: "POST"
        })
        .then(function(response) {
          let data = response.data;
          if (!data.error) {
            self.services = data;
          }
        });
    },
    getPlotData: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-documents/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            this.documents = data;
          }
        });
    },
    getPlotKppTypes: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-kpp-types/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          if (!data.error) {
            console.log(data);
            this.kppTypes = data;
          }
        });
    },
    getPlotFaces: function() {
      this.$store
        .dispatch("query/sendRequest", {
          url: this.url + "plots/get-plot-faces/",
          data: { ID: this.idPlot },
          method: "POST"
        })
        .then(response => {
          let data = response.data;
          console.log(data);
          if (!data.error) this.faces = data;
        });
    }
  },
  created() {
    this.getPlotData();
    this.getServicesList();
    this.getPlotFaces();
    this.getPlotKppTypes();
  }
};
</script>
